import { push } from 'connected-react-router'
import { QUOTE_SUMMARY_PAGE } from 'constant'

export const navigateToProperQuotePage = () => dispatch =>
  dispatch(push(QUOTE_SUMMARY_PAGE))
